// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__i_1sI","title":"Confirmation_title__1-QOw","content":"Confirmation_content__2Ha4M","toHome":"Confirmation_toHome__3oxJq"};